import { getToken } from "./auth";
import { adsConversionFor } from "./adsTag";

export const getSessionId = () => {
  let sid = sessionStorage.getItem("sid");
  if (!sid) {
    sid = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem("sid", sid);
  }
  return sid;
};

export const getDeviceType = () => {
  return window.innerWidth < 768 ? "mobile" : "desktop";
};

const getUserCity = () => {
  // If the user has a selected city in localStorage, use it, else null
  return localStorage.getItem("selectedCity") || null;
};

/* The same browser coming back - a random id kept on the device, nothing about the
   person. `newVisitor` marks the visit in which it was made, so the admin page can tell
   new visitors from returning ones. Storage can be blocked; then there is no id. */
let madeThisVisit = false;
const getVisitor = () => {
  try {
    let vid = localStorage.getItem("sramika_vid");
    if (!vid) {
      vid = `v${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem("sramika_vid", vid);
      sessionStorage.setItem("sramika_vid_new", "1");
      madeThisVisit = true;
    }
    return { visitorId: vid, newVisitor: madeThisVisit || sessionStorage.getItem("sramika_vid_new") === "1" };
  } catch {
    return {};
  }
};

/* Where this visit came from - read once, on its first event: a campaign tag
   (?utm_source=instagram), else the site that linked here, else "direct". */
const getSource = () => {
  try {
    if (sessionStorage.getItem("sramika_src_sent")) return undefined;
    sessionStorage.setItem("sramika_src_sent", "1");
    const utm = new URLSearchParams(window.location.search).get("utm_source");
    const ref = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, "") : "";
    const src = utm ? utm.toLowerCase().slice(0, 40)
      : ref && ref !== window.location.hostname.replace(/^www\./, "") ? ref.slice(0, 60) : "direct";
    // Kept for the visit, so a "Call me back" request says where the customer came from.
    sessionStorage.setItem("sramika_src", src);
    return src;
  } catch {
    return undefined;
  }
};

/** Where this visit came from (Google Ads, a poster, Instagram...), once known. */
export const visitSource = () => { try { return sessionStorage.getItem("sramika_src") || null; } catch { return null; } };

export const track = async (event, data = {}) => {
  // A call, a call back asked for: a Google Ads conversion too (utils/adsTag, when switched on).
  try { adsConversionFor(event); } catch { /* the tag never stops the event */ }
  try {
    const RAW_BASE = process.env.REACT_APP_API_BASE_URL;
    const NORMALIZED_BASE = RAW_BASE.replace(/\/+$/, "");
    const API_BASE_URL = NORMALIZED_BASE.endsWith("/api") ? NORMALIZED_BASE : `${NORMALIZED_BASE}/api`;

    await fetch(`${API_BASE_URL}/analytics/track`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`
      },
      body: JSON.stringify({
        event,
        ...data,
        timestamp: new Date().toISOString(),
        sessionId: getSessionId(),
        deviceType: getDeviceType(),
        city: getUserCity(),
        ...getVisitor(),
        source: getSource(),
        lang: (() => { try { return localStorage.getItem("app_lang") || undefined; } catch { return undefined; } })(),
      })
    });
  } catch (e) {
    // Never throw — analytics is non-critical, always silent
  }
};
